import script from "./LuckyHand.vue?vue&type=script&setup=true&lang=js"
export * from "./LuckyHand.vue?vue&type=script&setup=true&lang=js"

import "./LuckyHand.vue?vue&type=style&index=0&id=37ba4d72&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ba4d72"]])

export default __exports__